import { useTranslation } from 'react-i18next';
import {
  ApiExternalTransferChallengeCompleted,
  ApiExternalTransferChallengeRequired,
} from '../../../openapi';
import { FormContentIsland, Typography } from '@razz-team/ui-web';
import { useOtpResendMutation } from '../../../api/auth';
import { useCallback, useEffect, useState } from 'react';
import { addSeconds } from 'date-fns';
import { OtpField } from '../../Field/OtpField';
import { TransferComplete } from '../../TransferComplete/TransferComplete';
import { Navigate } from '@tanstack/react-router';
import { ReactNode } from 'react';

export function ChallengeRequired({
  entity,
  challenge,
  actions,
}: {
  entity: string;
  challenge: ApiExternalTransferChallengeRequired;
  actions?: ReactNode;
}) {
  const { t } = useTranslation();

  const otpResendMutation = useOtpResendMutation();
  const handleOtpResend = useCallback(() => {
    otpResendMutation.mutate({
      questId: challenge.questId,
    });
  }, [challenge.questId, otpResendMutation]);

  const [resendAllowedAt, setResendAllowedAt] = useState<Date | undefined>(undefined);
  useEffect(() => {
    if (otpResendMutation.data) {
      setResendAllowedAt(addSeconds(new Date(), otpResendMutation.data.resendInSec));
    } else if (challenge.otp) {
      setResendAllowedAt(addSeconds(new Date(), challenge.otp.resendInSec));
    }
  }, [challenge, otpResendMutation.data]);

  const otpError = otpResendMutation.error?.name;

  return (
    <FormContentIsland title={t('Confirm {{entity}}', { entity })} actions={actions}>
      <Typography variant="body1">
        {t('We sent a code to {{destination}}. Enter it here to confirm your {{entity}}.', {
          entity,
          destination: challenge.otp?.destination,
        })}
      </Typography>
      <OtpField
        name="solution"
        label={t('OTP code')}
        fullWidth
        required
        autoFocus
        error={Boolean(otpError)}
        helperText={otpError ? t(otpError) : undefined}
        resendAllowedAt={resendAllowedAt}
        onResend={handleOtpResend}
      />
    </FormContentIsland>
  );
}

export function TransferChallengeSuccess({
  challenge,
}: {
  challenge: ApiExternalTransferChallengeCompleted;
}) {
  const transaction = challenge.transactionInfo?.transaction;
  if (!transaction) {
    return <Navigate to="/account/transactions" />;
  }

  return <TransferComplete transaction={transaction} />;
}
